<template>
    <div class="row" v-if="display">
        <div class="col-lg-12" v-if="error">
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ error }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <label class="form-label">Utiliser un groupe</label>
                <el-select @change="$emit('choice', group_id)" style="width:100%" clearable v-model="group_id" filterable >
                    <el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
                <input type="hidden" :value="group_id" name="group_id">
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group" v-loading="loadingAdd">
                <label class="form-label">Ajouter un groupe</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="group" placeholder="Nom du groupe" aria-label="Nom du groupe" aria-describedby="button-add-group">
                    <div class="input-group-append">
                        <button @click="addGroup" class="btn btn-outline-secondary" type="button" id="button-add-group">Ajouter</button>
                    </div>
                </div>
                <div v-if="errorAdd" style="display: block" class="invalid-feedback">{{ errorAdd }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                group_id: null,
                groups: [],
                loading: false,
                loadingAdd: false,
                group: null,
                errorAdd: null,
                roleSelected: null
            }
        },
        props: {
            error: {
                default: null
            },
            userGroup: {
                default: null
            },
            role: {
                default: null
            }
        },
        computed: {
            display() {
                if(this.role === null) {
                    return this.roleSelected == 'pro' || this.roleSelected == 'pro+' || this.roleSelected == 'admin_domain'
                }
                return this.role == 'pro' || this.role == 'pro+' || this.role == 'admin_domain'
            }
        },
        mounted() {
            if( this.userGroup ) {
                this.group_id = parseInt(this.userGroup)
            }

            if(!this.role) {
                var selectRole = document.querySelector('select[name=role]')
                this.roleSelected = selectRole.value
                selectRole.addEventListener('change', (e)=>{
                    this.roleSelected = e.target.value
                    if( !this.display) {
                        this.resetForm();
                    }
                })
            }

            axios.get('/pro/groups', {params: { user_group: this.group_id }}).then((r)=>{
                this.groups = r.data.data
            }).catch((e)=>{
                console.error(e)
            }).then(()=>{
            })
        },
        methods: {
            resetForm() {
                this.group_id = null;
                this.group = null;
                this.groups = [];
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    axios.get('/pro/groups', {params: {query}}).then((r)=>{
                        this.groups = r.data.data
                    }).catch((e)=>{
                        console.error(e)
                    }).then(()=>{
                        this.loading = false;
                    })
                } else {
                    this.groups = [];
                }
            },

            addGroup()
            {
                if( this.group ) {
                    this.loadingAdd = true;
                    this.errorAdd = null;
                    axios.post('/pro/groups', {name:this.group}).then((r)=>{
                        this.group = null;
                        this.group_id = r.data.data.id
                        this.$emit('choice', this.group_id)
                        this.groups = [r.data.data]
                    }).catch((e)=>{
                        if( e.response.status == 422 ) {
                            console.log(e.response.data.errors.name[0]);
                            this.errorAdd = e.response.data.errors.name[0]
                        }

                    }).then(()=>{
                        this.loadingAdd = false
                    })
                }
            }
        }
    }
</script>
